import React, { useEffect, useState } from 'react'
import { CFormInput, CFormSelect, CInputGroup } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilSearch } from '@coreui/icons'

// Single search box + a field-picker dropdown, replacing per-column filter rows.
// Debounces text input, then reports { field, value } to the parent via onSearch.
const TableSearchToolbar = ({
  fields,
  field,
  onFieldChange,
  value,
  onSearch,
  placeholder = 'Search...',
  trailing = null,
}) => {
  const [text, setText] = useState(value || '')

  useEffect(() => {
    setText(value || '')
  }, [value, field])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (text !== (value || '')) onSearch(text)
    }, 350)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text])

  return (
    <div className="ge-table-toolbar d-flex flex-wrap align-items-center gap-2 mb-3">
      <CInputGroup className="ge-table-search">
        <CFormSelect
          className="ge-table-search-field"
          value={field}
          onChange={(e) => onFieldChange(e.target.value)}
          aria-label="Search field"
        >
          {fields.map((f) => (
            <option key={f.key} value={f.key}>
              {f.label}
            </option>
          ))}
        </CFormSelect>
        <span className="ge-table-search-icon">
          <CIcon icon={cilSearch} />
        </span>
        <CFormInput
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          aria-label="Search"
        />
      </CInputGroup>
      {trailing && <div className="ms-auto d-flex align-items-center gap-2">{trailing}</div>}
    </div>
  )
}

export default TableSearchToolbar
